import { render, staticRenderFns } from "./SpinnerButton.vue?vue&type=template&id=64d320af&scoped=true&"
import script from "./SpinnerButton.vue?vue&type=script&lang=ts&"
export * from "./SpinnerButton.vue?vue&type=script&lang=ts&"
import style0 from "./SpinnerButton.vue?vue&type=style&index=0&id=64d320af&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d320af",
  null
  
)

export default component.exports